import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AdminGuard } from './guard/admin.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./outside/outside.module').then(m => m.OutsideModule)
  },
  {
    path: 'inside',
    loadChildren: () => import('./inside/inside.module').then(m => m.InsideModule),
    canActivate: [AdminGuard],
  },
  {
    path: '**',
    redirectTo: 'inside/unidades'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
